import {State} from '../types'

export const getStaticMapUrl = (state: State) => state.staticMapUrl
